// TSS vite/04 §"Endpoint paths". No leading slash.
//
// A project's documentation is its documents: `kind` says which one (the api
// reference, the vision, the architecture…), and the text lives in versions,
// newest first. `documents:read` for both.
export const documentationPaths = {
    documents: () => 'admin/documents',
    versions:  (id) => `admin/documents/${id}/versions`,
};
